import Tool from '../../common/tool';
import WmRequest from '../../common/request';
import Config from '../../common/config';
import Login from '../login/login';
function hasUserLoginCookie() {
    return /(?:^|;\s*)UserLogin=1(?:;|$)/.test(document.cookie);
}
var HeaderMain = /** @class */ (function () {
    function HeaderMain() {
        this.megaHideTimer = 0;
        this.headerDom = document.getElementById('daetool-header');
        this.pathName = window.location.pathname;
        this.wmRequest = new WmRequest();
        this.init();
    }
    HeaderMain.prototype.init = function () {
        this.textActive();
        this.login();
        this.logout();
        this.invoiceBtnLogic();
        this.bindProductMegaMenu();
        this.bindHeaderSearch();
        this.bindHomeHeroHeader();
        this.loginList(); // 头像点击显示下拉列表
        // this.normalizeMegaProductLinksWithDomain()
    };
    /**
     * 开发临时：后端 details_url 为测试服完整 URL 时，仅替换 baseURL 为模板 domain，保留路径。
     */
    HeaderMain.prototype.normalizeMegaProductLinksWithDomain = function () {
        var domain = (this.headerDom.dataset.domain || '').replace(/\/$/, '');
        if (!domain) {
            return;
        }
        var productLinks = this.headerDom.querySelectorAll('.daetool-header-mega-panel__product[href]');
        productLinks.forEach(function (link) {
            var href = link.getAttribute('href') || '';
            if (!href) {
                return;
            }
            if (href.startsWith('/')) {
                link.href = "".concat(domain).concat(href);
                return;
            }
            if (!/^https?:\/\//i.test(href)) {
                link.href = "".concat(domain, "/").concat(href.replace(/^\/+/, ''));
                return;
            }
            try {
                var url = new URL(href);
                link.href = "".concat(domain).concat(url.pathname).concat(url.search).concat(url.hash);
            }
            catch (_a) {
                // keep original href
            }
        });
    };
    /** 首页 / 产品中心 / 帮助中心：导航叠在 banner 上，顶部半透明，滚动后实底 */
    HeaderMain.prototype.bindHomeHeroHeader = function () {
        var _this = this;
        var heroBanner = document.getElementById('daetool-home-banner')
            || document.querySelector('.daetool-procenter-banner')
            || document.querySelector('.daetool-support-banner');
        if (!heroBanner) {
            return;
        }
        var SCROLL_THRESHOLD = 16;
        this.headerDom.classList.add('is-over-hero');
        var syncScrollState = function () {
            _this.headerDom.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
        };
        syncScrollState();
        window.addEventListener('scroll', syncScrollState, { passive: true });
    };
    /** 顶部搜索框提交：无关键词不跳转；有关键词进入搜索结果页 */
    HeaderMain.prototype.bindHeaderSearch = function () {
        var form = this.headerDom.querySelector('.daetool-header-search');
        if (!form) {
            return;
        }
        var goSearch = function (event) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            var input = form.querySelector('.daetool-header-search__input');
            var keyword = (input === null || input === void 0 ? void 0 : input.value.trim()) || '';
            if (!keyword) {
                return;
            }
            var params = new URLSearchParams({
                keywords: keyword,
                tab: 'article',
                page: '1',
            });
            window.location.href = "/searchResult?".concat(params.toString());
        };
        form.addEventListener('submit', goSearch);
        var submitBtn = form.querySelector('.daetool-header-search__submit');
        submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.addEventListener('click', goSearch);
    };
    HeaderMain.prototype.bindProductMegaMenu = function () {
        var _this = this;
        var navTypes = Array.from(Tool.$_selectAll(this.headerDom, '.daetool-header-nav-type'));
        var panels = Array.from(Tool.$_selectAll(this.headerDom, '.daetool-header-mega-panel'));
        var megaLayer = this.headerDom.querySelector('.daetool-header-mega-layer');
        var overlay = this.headerDom.querySelector('.black-overlay');
        if (!navTypes.length || !panels.length || !megaLayer) {
            return;
        }
        var clearHideTimer = function () {
            if (_this.megaHideTimer) {
                window.clearTimeout(_this.megaHideTimer);
                _this.megaHideTimer = 0;
            }
        };
        var scheduleHide = function () {
            clearHideTimer();
            _this.megaHideTimer = window.setTimeout(function () {
                _this.hideMegaMenu(navTypes, panels, megaLayer, overlay);
            }, 120);
        };
        var showPanel = function (typeAlias) {
            clearHideTimer();
            navTypes.forEach(function (nav) {
                nav.classList.toggle('is-active', nav.getAttribute('data-type-alias') === typeAlias);
            });
            panels.forEach(function (panel) {
                var isActive = panel.getAttribute('data-type-alias') === typeAlias;
                panel.classList.toggle('is-active', isActive);
            });
            megaLayer.classList.add('is-open');
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.add('show');
            _this.headerDom.classList.add('is-mega-open');
        };
        navTypes.forEach(function (nav) {
            nav.addEventListener('mouseenter', function () {
                var typeAlias = nav.getAttribute('data-type-alias');
                if (typeAlias) {
                    showPanel(typeAlias);
                }
            });
        });
        megaLayer.addEventListener('mouseenter', clearHideTimer);
        megaLayer.addEventListener('mouseleave', scheduleHide);
        navTypes.forEach(function (nav) {
            nav.addEventListener('mouseleave', function (event) {
                var related = event.relatedTarget;
                if (related && (megaLayer.contains(related) || nav.contains(related))) {
                    return;
                }
                scheduleHide();
            });
        });
    };
    HeaderMain.prototype.hideMegaMenu = function (navTypes, panels, megaLayer, overlay) {
        navTypes.forEach(function (nav) { return nav.classList.remove('is-active'); });
        panels.forEach(function (panel) { return panel.classList.remove('is-active'); });
        megaLayer.classList.remove('is-open');
        overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove('show');
        this.headerDom.classList.remove('is-mega-open');
    };
    HeaderMain.prototype.textActive = function () {
        var _a;
        // 一级导航栏文字设置活跃状态
        if (this.pathName.includes('/support')) {
            (_a = this.headerDom.querySelector('.daetool-header-center-support')) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        }
    };
    HeaderMain.prototype.login = function () {
        var that = this;
        // 登录：一级导航栏触发
        var hasLoginBtn = document.body.contains(document.getElementsByClassName('daetool-header-right-no-login')[0]);
        if (hasLoginBtn) {
            var loginBtn = Tool.$_select(that.headerDom, '.daetool-header-right-no-login');
            loginBtn.addEventListener('click', function () {
                new Login();
            });
        }
        // 政企采购首页登录：页面元素触发
        if (this.pathName == '/purchase') {
            var purchaseDom = document.getElementById('purchase');
            var toPurchasePayBtns = Tool.$_selectAll(purchaseDom, '.toPurchasePay');
            toPurchasePayBtns.forEach(function (item) {
                item.addEventListener('click', function () {
                    var jumpToUrl = item.getAttribute('data-jumpto');
                    if (isLogin == 1) {
                        window.open(jumpToUrl);
                    }
                    else {
                        new Login(jumpToUrl);
                    }
                });
            });
            var toExchangeCodeBtn_1 = Tool.$_select(purchaseDom, '.toExchangeCode');
            toExchangeCodeBtn_1.addEventListener('click', function () {
                var jumpToUrl = toExchangeCodeBtn_1.getAttribute('data-jumpto');
                if (isLogin == 1) {
                    window.open(jumpToUrl);
                }
                else {
                    new Login(jumpToUrl);
                }
            });
        }
        if (this.pathName == '/purchasePay' ||
            this.pathName == '/ExchangeCode' ||
            this.pathName.includes('/user')) {
            if (isLogin == 0) {
                new Login();
            }
        }
    };
    HeaderMain.prototype.logout = function () {
        var _this = this;
        var that = this;
        // 退出
        var hasLogOutBtn = document.body.contains(document.getElementsByClassName('daetool-header-right-logout')[0]);
        if (hasLogOutBtn) {
            var logOutBtn = Tool.$_select(that.headerDom, '.daetool-header-right-logout');
            logOutBtn.addEventListener('click', function () {
                that.wmRequest.ajax({
                    type: 'GET',
                    url: Config.WM_LOGINOUT
                }).then(function (res) {
                    if (res.code == 200) {
                        if (_this.pathName.includes('/user')) {
                            window.location.href = '/';
                        }
                        else if (_this.pathName.includes('/purchasePay')) {
                            window.location.href = '/purchase';
                        }
                        else {
                            window.location.reload();
                        }
                    }
                });
            });
        }
    };
    // 可开发票按钮判断是否登录
    // 带有invoiceBtn-logic类名即可，data-jumpto属性可选
    HeaderMain.prototype.invoiceBtnLogic = function () {
        var _this = this;
        var invoiceBtns = document.querySelectorAll('.invoiceBtn-logic');
        invoiceBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                var targetUrl = btn.getAttribute('data-jumpto') || '/user#myOrder';
                if (_this.pathName.includes('/specialPay')) {
                    if (hasUserLoginCookie()) {
                        window.location.href = targetUrl;
                    }
                    else {
                        new Login(targetUrl);
                    }
                }
                else if (isLogin == 1) {
                    window.open(targetUrl, '_blank');
                }
                else {
                    new Login(targetUrl);
                }
            });
        });
    };
    HeaderMain.prototype.loginList = function () {
        var _this = this;
        var headPortraitDom = Tool.$_select(this.headerDom, '.daetool-header-right-login >img');
        if (headPortraitDom) {
            headPortraitDom.addEventListener('click', function (e) {
                e.preventDefault();
                var loginContentDom = Tool.$_select(_this.headerDom, '.daetool-header-right-login-content');
                if (loginContentDom) {
                    loginContentDom.classList.toggle('active');
                }
            });
        }
    };
    return HeaderMain;
}());
export default HeaderMain;
